import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addDocumentData,
  deleteDocumentData,
  fetchDocumentListData,
  fetchDocumentTypeListData,
  updateDocumentData,
} from "../../apis/documents";

export const fetchDocumentList = createAsyncThunk(
  "document/fetchDocumentList",
  async (
    {
      jobId,
      // params,
    }: {
      jobId: string;
      // params: {
      //   page: number;
      //   pageSize: number;
      // };
    },
    { rejectWithValue }
  ) => {
    try {
      const documentList = await fetchDocumentListData(jobId);
      return {
        id: jobId,
        data: documentList,
      };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchDocumentTypeList = createAsyncThunk(
  "document/fetchDocumentTypeList",
  async (_, { rejectWithValue }) => {
    try {
      const documentList = await fetchDocumentTypeListData();
      return documentList;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateDocument = createAsyncThunk(
  "document/updateDocument",
  async (
    {
      id,
      jobId,
      data,
    }: {
      id: string;
      jobId: string;
      data: {
        [key: string]: any;
        documentId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateDocumentData(id, data);
      return {
        id: jobId,
        data: result.data,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteDocument = createAsyncThunk(
  "document/deleteDocument",
  async (
    {
      id,
      jobId,
    }: {
      id: string;
      jobId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteDocumentData(id, jobId);
      return {
        jobId,
        id: response.id,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewDocumentData = createAsyncThunk(
  "document/addNewDocumentData",
  async (
    {
      data,
      jobId,
    }: {
      data: {
        [key: string]: any;
      };
      jobId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addDocumentData(data, jobId);
      return {
        jobId,
        data: response,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
